// Hva en sjåfør kan gjøre med et åpent oppdrag, utledet av prisfeltene.
// Fastpris er taket bestiller godtar:
//   autoAccept            – sjåfør kan godta fastprisen direkte (førstemann til mølla)
//   allowBids             – bestiller tillater i tillegg bud under fastprisen
// Uten fastpris (forseglet anbud) eller uten autoAccept er det bare bud.

export function hasFixedPrice(order) {
  return Number.isInteger(order?.fixedPrice) && order.fixedPrice > 0;
}

export function canTake(order) {
  return order?.autoAccept === true && hasFixedPrice(order);
}

export function canBid(order) {
  return !hasFixedPrice(order) || order.autoAccept !== true || order.allowBids === true;
}

// Kort tekst som viser hvordan oppdraget prises, for lista og kartet:
//   Fastpris         – godta direkte, ingen bud
//   Fastpris · bud   – godta direkte eller by under
//   Maks · bud       – bare bud, og fastprisen er taket
//   Åpent for bud    – forseglet anbud uten fastpris
export function priceKindLabel(order) {
  if (!hasFixedPrice(order)) return 'Åpent for bud';
  if (canTake(order)) return canBid(order) ? 'Fastpris · bud' : 'Fastpris';
  return 'Maks · bud';
}

// Høyeste bud som er tillatt, eller null når det ikke finnes tak
export function maxBid(order) {
  return hasFixedPrice(order) ? order.fixedPrice : null;
}
